import { render, staticRenderFns } from "./BookPage.vue?vue&type=template&id=76fb6d70&scoped=true&"
import script from "./BookPage.vue?vue&type=script&lang=js&"
export * from "./BookPage.vue?vue&type=script&lang=js&"
import style0 from "./BookPage.vue?vue&type=style&index=0&id=76fb6d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fb6d70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76fb6d70')) {
      api.createRecord('76fb6d70', component.options)
    } else {
      api.reload('76fb6d70', component.options)
    }
    module.hot.accept("./BookPage.vue?vue&type=template&id=76fb6d70&scoped=true&", function () {
      api.rerender('76fb6d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BookPage.vue"
export default component.exports